import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
// import {
//   createBody,
//   uploadImage,
// } from "../../../../redux/actions/createcampaign";
import { Add } from "@mui/icons-material";
import { Box, Button, Grid, MenuItem, Paper, TextField, Toolbar, Tooltip } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import {
  updateBody,
  updateImage,
} from "../../../redux/actions/addCampaigndata";
import CircularProgress from "@mui/material/CircularProgress";
import { Col, Row } from "react-bootstrap";
import JoditEditor from "jodit-react";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StarRateIcon from '@mui/icons-material/StarRate';
import DeleteIcon from "@mui/icons-material/Delete";
import { uploadImage } from "../../../redux/actions/createcampaign";
import './updateBody.css';
import { motion } from "framer-motion";

const logoSchema = yup.array().of(
  yup.object().shape({
    file: yup
      .mixed()
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) {
          return true;
        }
        const file = value.file;
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
        return supportedFormats.includes(fileExtension);
      }),
    link: yup.string(),
    target: yup.string(),
    order: yup.string().required(),
    alt: yup.string(),
  })
);

const logoSchemaPromotion = yup.array().of(
  yup.object().shape({
    file: yup
      .mixed()
      .nullable()
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) {
          return true;
        }
        const file = value.file;
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
        return supportedFormats.includes(fileExtension);
      }),
    link: yup.string().url(),
    target: yup.string(),
    order: yup.string(),
    alt: yup.string(),
  })
).notRequired();


const logoSchemaForPartners = yup.array().of(
  yup.object().shape({
    file: yup
      .mixed()
      .required("Image is required")
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) {
          return true;
        }
        const file = value.file;
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
        return supportedFormats.includes(fileExtension);
      }),
    order: yup.string(),
  })
);

const schema = yup.object().shape({
  main_banner_desktop: logoSchema,
  campaignId: yup.string().required("Campaign ID is required"),
  uiType: yup.string().required("UI Type is required"),
  main_heading: yup.string().required("main_heading is required"),
  main_subHeading: yup.string().required("main_subHeading is required"),
  disclaimer: yup.string().required("disclaimer is required"),
  main_banner_mobile: logoSchema,
  partners: logoSchemaForPartners,
  partners_subHeading: yup.string(),
  partners_heading: yup.string(),
  promotional_banner_desktop: logoSchemaPromotion,
  promotional_banner_mobile: logoSchemaPromotion,
  detail_banner_desktop: logoSchemaPromotion,//future change if required
  detail_banner_mobile: logoSchemaPromotion,
  is_paid: yup.boolean().notRequired(),
});

const UpdateBody = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const uiType = localStorage.getItem("uiType");
  const selector = useSelector((state) => state.addCampaignReducer);
  const campaignId = localStorage.getItem("campaignId") ?? selector.campaignId;
  const data = useSelector((state) => state.addCampaignReducer.dataAll);
  const [isChecked, setIsChecked] = useState({ detail_banner_desktop: false, detail_banner_mobile: false, is_paid: false });


  const [images] = useState(() => {
    return {
      mainDesktop: data?.main_banner_desktop?.map((e) => e.image),
      detailsDesktop: data?.detail_banner_desktop?.map((e) => e.image),
      mainMobile: data?.main_banner_mobile?.map((e) => e.image),
      detailsMobile: data?.detail_banner_mobile?.map((e) => e.image),
      partners: data?.partners?.map((e) => e.logo),
      promotional_banner_desktop: data?.promotional_banner_desktop?.map((e) => e.image),
      promotional_banner_mobile: data?.promotional_banner_mobile?.map((e) => e.image),
    };
  });

  const disclaimerData = data?.disclaimer;
  const footerContentData=data?.footer_content;

  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/view-campaign");
  };

  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
    register,
    clearErrors,
    setError,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),

    defaultValues: {
      main_heading: "",
      main_subHeading: "",
      uiType: "",
      campaignId: "",
      disclaimer: "",
      footer_content:"",
      main_banner_desktop: [
        { file: images?.mainDesktop, link: "", target: "", order: "", alt: "" },
      ],
      main_banner_mobile: [
        { file: images?.mainMobile, link: "", target: "", order: "", alt: "" },
      ],
      deleteUrl: [],
      partners: [{ file: images?.partners, order: "" }],
      partners_subHeading: "",
      partners_heading: "",
      promotional_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      promotional_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      detail_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      detail_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      is_paid: false,
    },
  });

  const {
    fields: photoFields,
    append: appendPhoto,
    remove: removePhoto,
  } = useFieldArray({
    control,
    name: "main_banner_mobile",
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "main_banner_desktop",
  });


  const {
    fields: partnersFields,
    append: partnersAppend,
    remove: partnersRemove,
  } = useFieldArray({
    control,
    name: "partners",
  });

  const { fields: promotionFields, append: promotionalAppend, remove: promotionalRemove } = useFieldArray({ control, name: "promotional_banner_desktop", });

  const { fields: promotionFieldsMobile, append: promotionalAppendMobile, remove: promotionalRemoveMobile } = useFieldArray({ control, name: "promotional_banner_mobile", });

  const {
    fields: detailDesktopFields,
    append: detailDesktopAppend,
    remove: detailDesktopRemove,
  } = useFieldArray({ control, name: "detail_banner_desktop" });
  const {
    fields: detailMobileFields,
    append: detailMobileAppend,
    remove: detailMobileRemove,
  } = useFieldArray({ control, name: "detail_banner_mobile" });

  const user = localStorage.getItem("userID");

  const handleEditor = (value) => {
    if (value === "") {
      setError("Enter your Disclaimer Here.")
    } else {
      setValue('disclaimer', value);
      setError("");
    }
  }

  const handleFooterContentEditor = (value) => {
     if (value === "") {
      setError("Enter your Footer Content Here.")
    } else {
     setValue('footer_content', value);
      setError("");
    }
  
  }



  // collapse state
  const [columnVisibility, setColumnVisibility] = useState({
    mainDesktop: false,
    mainMobile: false,
    partners: false,
    detailsDesktop: false,
    detailsMobile: false,
    promotional_banner_mobile: false,
    promotional_banner_desktop: false,
    paid: false
  });

  const toggleColumn = (columnName) => {
    setColumnVisibility({
      ...columnVisibility,
      [columnName]: !columnVisibility[columnName],
    });
  };




  const handleImage = async (index, logo, e) => {
    const file = e.target.files[0];

    const isImage = file && file.type.startsWith("image/");
    const formData = new FormData();
    formData.append("image", file);

    if (!isImage) {
      setError(`${logo}[${index}].file`, {
        type: "manual",
        message: "Invalid file type. Please select a valid image.",
      });
      return;
    }

    if (logo === "main_banner_desktop" || logo === "main_banner_mobile") {
      clearErrors(`${logo}[${index}].file`);
      if (images?.mainDesktop[index] || images?.mainMobile[index]) {
        formData.append("deleted_by", user);
        formData.append("link", logo === "main_banner_desktop" ? images?.mainDesktop[index] : images?.mainMobile[index]);
        dispatch(updateImage(formData)).then((res) => {
          setValue(`${logo}[${index}].image`, res);
          setValue(`${logo}[${index}].file`, res);
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`${logo}[${index}].image`, res);
          setValue(`${logo}[${index}].file`, res);
        });
      }
    } else if (logo === "promotional_banner_mobile" || logo === "promotional_banner_desktop") {
      clearErrors(`${logo}[${index}].file`);
      if (images?.promotional_banner_desktop[index] || images?.promotional_banner_mobile[index]) {
        formData.append("deleted_by", user);
        formData.append("link", logo === "promotional_banner_desktop" ? images?.promotional_banner_desktop[index] : images?.promotional_banner_mobile[index]);
        dispatch(updateImage(formData)).then((res) => {
          setValue(`${logo}[${index}].image`, res);
          setValue(`${logo}[${index}].file`, res);
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`${logo}[${index}].image`, res);
          setValue(`${logo}[${index}].file`, res);
        });
      }
    } else if (logo === "detail_banner_desktop" || logo === "detail_banner_mobile") {
      clearErrors(`${logo}[${index}].file`);
      if (images?.detailsDesktop[index] || images?.detailsMobile[index]) {
        formData.append("deleted_by", user);
        formData.append("link", logo === "detail_banner_desktop" ? images?.detailsDesktop[index] : images?.detailsMobile[index]);
        dispatch(updateImage(formData)).then((res) => {
          setValue(`${logo}[${index}].image`, res);
          setValue(`${logo}[${index}].file`, res);
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`${logo}[${index}].image`, res);
          setValue(`${logo}[${index}].file`, res);
        });
      }
    } else if (logo === "partners") {
      clearErrors(`${logo}[${index}].file`);
      if (images?.partners[index]) {
        formData.append("deleted_by", user);
        formData.append("link", images?.partners);
        dispatch(updateImage(formData)).then((res) => {
          setValue(`${logo}[${index}].logo`, res);
          setValue(`${logo}[${index}].file`, res);
        });
      } else {
        dispatch(uploadImage(formData)).then((res) => {
          setValue(`${logo}[${index}].logo`, res);
          setValue(`${logo}[${index}].file`, res);
        });
      }
    }
  };



  const onSubmit = async (data) => {
    const recreatedDesktopArray = data?.main_banner_desktop?.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    const recreatedMobileArray = data?.main_banner_mobile?.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    const recreatedMobileArrayDetail = data.detail_banner_mobile.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });
    const reacreatedDesktopArrayDetail = data.detail_banner_desktop.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    let { uiType, campaignId, ...NewData } = data;
    const recreatedData = {
      ...NewData,
      main_banner_desktop: recreatedDesktopArray,
      main_banner_mobile: recreatedMobileArray,
      detail_banner_desktop: reacreatedDesktopArrayDetail,
      detail_banner_mobile: recreatedMobileArrayDetail,
      updated_by: user,
      campaign_Id: campaignId,
      ui_type: uiType,
      campaign_name: localStorage.getItem("campaign_name") || data?.campaign_name,
    };
    setIsLoading(true);
    const result = await dispatch(updateBody(recreatedData));
    if (result?.success === true) {
      setTimeout(() => {
        setIsLoading(false);
        handleBack();
      }, 1000);
    } else {
      handleBack();
    }
  };

  useEffect(() => {
    if (uiType !== null && uiType !== undefined) {
      setValue("uiType", uiType);
    }
    if (campaignId !== null && campaignId !== undefined) {
      setValue("campaignId", campaignId);
    }
  }, [uiType, campaignId]);

  useEffect(() => {
    if (data) {
      setValue("main_banner_desktop", data?.main_banner_desktop);
      data?.main_banner_desktop?.forEach((img, index) => {
        const { image } = img || {};
        setValue(`main_banner_desktop[${index}].file`, image);
      });
      setValue("main_banner_mobile", data?.main_banner_mobile);
      data?.main_banner_mobile?.map((img, index) => {
        const { image } = img || {};
        setValue(`main_banner_mobile[${index}].file`, image);
      });
      setValue("detail_banner_desktop", data?.detail_banner_desktop);
      data?.detail_banner_desktop?.map((img, index) => {
        const { image } = img || {};
        setValue(`detail_banner_desktop[${index}].file`, image);
      });

      setIsChecked((prev) => ({
        ...prev,
        detail_banner_desktop: data?.detail_banner_desktop?.length > 0,
        detail_banner_mobile: data?.detail_banner_mobile?.length > 0,
        is_paid: data?.is_paid,
      }));

      setValue("detail_banner_mobile", data?.detail_banner_mobile);
      data?.detail_banner_mobile?.length > 0 && data?.detail_banner_mobile?.map((img, index) => {
        const { image } = img || {};
        setValue(`detail_banner_mobile[${index}].file`, image);
      });
      setValue("main_heading", data?.main_heading);
      setValue("main_subHeading", data?.main_subHeading);
      setValue("disclaimer", data?.disclaimer);
      setValue("footer_content",data?.footer_content);
      setValue("campaignId", data?.campaign_Id);
      setValue("promotional_banner_desktop", data?.promotional_banner_desktop);
      setValue("promotional_banner_mobile", data?.promotional_banner_mobile);
      setValue("partners_heading", data?.partners_heading);
      setValue("partners_subHeading", data?.partners_subHeading);
      setValue("partners", data?.partners);
      setValue("is_paid", data?.is_paid);
      data?.promotional_banner_desktop?.map((img, index) => (
        setValue(`promotional_banner_desktop[${index}].file`, img?.image)
      ))
      data?.promotional_banner_mobile?.map((img, index) => (
        setValue(`promotional_banner_mobile[${index}].file`, img?.image)
      ))
      data?.partners?.map((img, index) => (
        setValue(`partners[${index}].file`, img?.logo)
      ))
      setValue("uiType", data?.ui_type);
    }
  }, [data]);

  const handleUrlChange = (index, logo, e) => {
    const urlValue = e.target.value.trim();
    if (logo === "main_banner_desktop" || logo === "main_banner_mobile" || logo === "promotional_banner_mobile" || logo === "promotional_banner_desktop" || logo === "detail_banner_desktop" || logo === "detail_banner_mobile") {
      clearErrors(`${logo}[${index}].file`);
      setValue(`${logo}[${index}].image`, urlValue);
      setValue(`${logo}[${index}].file`, urlValue);
    } else if (logo === "partners") {
      clearErrors(`${logo}[${index}].file`);
      setValue(`${logo}[${index}].logo`, urlValue);
      setValue(`${logo}[${index}].file`, urlValue);
    }
  };

  const handleCheckboxChange = (event, field) => {
    if (field === "detail_banner_desktop" || field === "detail_banner_mobile") {
      if (event.target.checked) {
        setValue(`${field}`, field === "detail_banner_desktop" ? [...watch('main_banner_desktop')] : [...watch('main_banner_mobile')]);
        setIsChecked({ ...isChecked, [field]: event.target.checked });
      } else {
        setValue(`${field}`, [{ file: null, link: "", target: "_self", order: "", alt: "" }]);
        setIsChecked({ ...isChecked, [field]: event.target.checked });
      }
    } else if (field === "is_paid") {
      setValue(`${field}`, event.target.checked);
      setIsChecked({ ...isChecked, [field]: event.target.checked });
    }
  };


  console.log(errors, 'errors')



  return (
    <Box sx={{ width: "98%" }}>
      <Paper elevation={3} sx={{ padding: "1.5rem" }}>
        <div className="">
          <form onSubmit={handleSubmit(onSubmit)}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="text-center fw-bold mb-3 border-bottom border-2 border-info pb-1"
              style={{ fontSize: "20px", color: "rgba(0, 165, 162, 0.9)" }}
            >
              Update Your Body Section
            </motion.div>
            <div className="container">
              <Row>
                <Col lg={6} className=" mb-3">
                  <div className="d-flex justify-content-evenly">
                    <div className="text-success fw-bold text-center buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('paid')}>
                      Update Paid Or Not <StarRateIcon />  {columnVisibility.paid ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                    </div>
                  </div>
                  <div style={{ display: columnVisibility.paid ? 'block ' : 'none' }}>
                    <Tooltip title="Please update the campaign is paid or not">
                      <div className="d-flex justify-content-center align-items-center mt-3">
                        <div className="checkbox-container ">
                          <input
                            type="checkbox"
                            id="isPaidCheckbox"
                            checked={isChecked?.is_paid}
                            onChange={(e) => handleCheckboxChange(e, "is_paid")}
                          />
                          <label htmlFor="isPaidCheckbox" className="custom-checkbox-label">
                            <span className="slider"></span>
                          </label>
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="text-success fw-bold text-center buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('mainDesktop')}>
                    Update Main Banner Desktop  <StarRateIcon />  {columnVisibility.mainDesktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                  </div>
                  <div style={{ display: columnVisibility.mainDesktop ? 'block' : 'none' }}>
                    {fields?.map((item, index) => (
                      <div key={item.id} className="form-row ">
                        <div className="d-flex justify-content-around mb-3 mt-2">
                          <Button
                            variant="contained"
                            component="label"
                            {...register(`main_banner_desktop[${index}].file`)}
                            onClick={() => clearErrors(`main_banner_desktop[${index}].file`)} // Clear errors for URL when file input is clicked
                          >
                            Upload Banner
                            <input
                              type="file"
                              {...register(`main_banner_desktop[${index}].file`)}
                              hidden
                              onChange={(e) => handleImage(index, "main_banner_desktop", e)}
                              className={`file_button mb-1 ${errors.main_banner_desktop && errors?.main_banner_desktop?.file ? "error" : ""}`}
                            />
                          </Button>
                          {watch(`main_banner_desktop[${index}].image`) && (
                            <div className="image_div">
                              <img
                                src={watch(`main_banner_desktop[${index}].image`)}
                                alt=""
                                width={100}
                                height="auto"
                                className="rounded image"
                              />
                            </div>
                          )}
                        </div>

                        <div className="column mb-2">
                          <Controller
                            name={`main_banner_desktop[${index}].file`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Update Main Banner Desktop Image Url"
                                className={`form-control mb-2 ${errors.main_banner_desktop &&
                                  errors?.main_banner_desktop[index]?.file
                                  ? "error"
                                  : ""
                                  }`}
                                value={field?.value || ""}
                                onChange={(e) => handleUrlChange(index, "main_banner_desktop", e)}
                              />
                            )}
                          />

                          <Controller
                            name={`main_banner_desktop[${index}].link`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Link"
                                className={`form-control mb-2 ${errors.main_banner_desktop &&
                                  errors?.main_banner_desktop[index]?.link
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                        </div>
                        <div className="d-flex gap-3 mb-2">
                          <Controller
                            name={`main_banner_desktop[${index}].target`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Target"
                                select
                                className={`form-control mb-2 ${errors.main_banner_desktop &&
                                  errors?.main_banner_desktop[index]?.target
                                  ? "error"
                                  : ""
                                  }`}
                              >
                                <MenuItem value="_self">_self</MenuItem>
                                <MenuItem value="_blank">_blank</MenuItem>
                              </TextField>
                            )}
                          />
                          <Controller
                            name={`main_banner_desktop[${index}].order`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Order"
                                select
                                className={`form-control mb-2 ${errors.main_banner_desktop &&
                                  errors?.main_banner_desktop[index]?.order
                                  ? "error"
                                  : ""
                                  }`}
                              >
                                {[...Array(15).keys()].map((number) => (
                                  <MenuItem
                                    key={number + 1}
                                    value={(number + 1).toString()}
                                  >
                                    {number + 1}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          />
                        </div>
                        <div className="column">
                          <Controller
                            name={`main_banner_desktop[${index}].alt`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Alt"
                                className={`form-control ${errors.main_banner_desktop &&
                                  errors?.main_banner_desktop[index]?.alt
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                        </div>
                        <div className="column d-flex justify-content-end mt-2">
                          {fields.length > 0 &&
                            <Tooltip title="Delete" arrow>
                              <DeleteIcon onClick={() => remove(index)} style={{ color: "red", cursor: "pointer" }} />
                            </Tooltip>
                          }
                        </div>
                      </div>
                    ))}
                    <Grid className="d-flex justify-content-between">
                      <Toolbar className="p-0">
                        <Button
                          className="button "
                          variant="outlined"
                          disableElevation
                          startIcon={<Add />}
                          onClick={() =>
                            append({
                              file: null,
                              link: "",
                              target: "",
                              order: "",
                              alt: "",
                            })
                          }
                        >
                          Add
                        </Button>
                      </Toolbar>
                    </Grid>
                  </div>
                  <hr />
                </Col>
                <Col lg={6}>
                  <div className="d-flex justify-content-evenly">
                    <div className="text-success fw-bold text-center buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('detailsDesktop')}>
                      Update Details Banner Desktop <StarRateIcon />  {columnVisibility.detailsDesktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                    </div>
                    <Tooltip title="Copy Main Banner Desktop to Details Banner Desktop">
                      <div className="checkbox-container mt-2">
                        <input type="checkbox" checked={isChecked?.detail_banner_desktop} onChange={(e) => handleCheckboxChange(e, "detail_banner_desktop")} id="detailDesktop" />
                        <label htmlFor="detailDesktop" className="custom-checkbox-label">
                          <span className="slider"></span>
                        </label>
                      </div>
                    </Tooltip>
                  </div>
                  <div style={{ display: columnVisibility.detailsDesktop ? 'block' : 'none' }}>
                    {detailDesktopFields?.map((item, index) => (
                      <div key={item.id} className="form-row ">
                        <div className="d-flex justify-content-around mb-3 mt-2">
                          <Button
                            variant="contained"
                            component="label"
                            {...register(`detail_banner_desktop[${index}].file`)}
                            onClick={() => clearErrors(`detail_banner_desktop[${index}].file`)} // Clear errors for URL when file input is clicked
                          >
                            Upload Banner
                            <input
                              type="file"
                              {...register(`detail_banner_desktop[${index}].file`)}
                              hidden
                              onChange={(e) => handleImage(index, "detail_banner_desktop", e)}
                              className={`file_button mb-1 ${errors.detail_banner_desktop && errors?.detail_banner_desktop?.file ? "error" : ""}`}
                            />
                          </Button>
                          {watch(`detail_banner_desktop[${index}].image`) && (
                            <div className="image_div">
                              <img
                                src={watch(`detail_banner_desktop[${index}].image`)}
                                alt=""
                                width={100}
                                height="auto"
                                className="rounded image"
                              />
                            </div>
                          )}
                        </div>

                        <div className="column mb-2">
                          <Controller
                            name={`detail_banner_desktop[${index}].file`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Update Main Banner Desktop Image Url"
                                className={`form-control mb-2 ${errors.detail_banner_desktop &&
                                  errors?.detail_banner_desktop[index]?.file
                                  ? "error"
                                  : ""
                                  }`}
                                value={field?.value || ""}
                                onChange={(e) => handleUrlChange(index, "detail_banner_desktop", e)}
                              />
                            )}
                          />

                          <Controller
                            name={`detail_banner_desktop[${index}].link`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Link"
                                className={`form-control mb-2 ${errors.detail_banner_desktop &&
                                  errors?.detail_banner_desktop[index]?.link
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                        </div>
                        <div className="d-flex gap-3 mb-2">
                          <Controller
                            name={`detail_banner_desktop[${index}].target`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Target"
                                select
                                className={`form-control mb-2 ${errors.detail_banner_desktop &&
                                  errors?.detail_banner_desktop[index]?.target
                                  ? "error"
                                  : ""
                                  }`}
                              >
                                <MenuItem value="_self">_self</MenuItem>
                                <MenuItem value="_blank">_blank</MenuItem>
                              </TextField>
                            )}
                          />
                          <Controller
                            name={`detail_banner_desktop[${index}].order`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Order"
                                select
                                className={`form-control mb-2 ${errors.detail_banner_desktop &&
                                  errors?.detail_banner_desktop[index]?.order
                                  ? "error"
                                  : ""
                                  }`}
                              >
                                {[...Array(15).keys()].map((number) => (
                                  <MenuItem
                                    key={number + 1}
                                    value={(number + 1).toString()}
                                  >
                                    {number + 1}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          />
                        </div>
                        <div className="column">
                          <Controller
                            name={`detail_banner_desktop[${index}].alt`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Alt"
                                className={`form-control ${errors.detail_banner_desktop &&
                                  errors?.detail_banner_desktop[index]?.alt
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                        </div>
                        <div className="column d-flex justify-content-end mt-2">
                          {detailDesktopFields.length > 0 &&
                            <Tooltip title="Delete" arrow>
                              <DeleteIcon onClick={() => detailDesktopRemove(index)} style={{ color: "red", cursor: "pointer" }} />
                            </Tooltip>
                          }
                        </div>
                      </div>
                    ))}
                    <Grid className="d-flex justify-content-between">
                      <Toolbar className="p-0">
                        <Button
                          className="button "
                          variant="outlined"
                          disableElevation
                          startIcon={<Add />}
                          onClick={() =>
                            detailDesktopAppend({
                              file: null,
                              link: "",
                              target: "",
                              order: "",
                              alt: "",
                            })
                          }
                        >
                          Add
                        </Button>
                      </Toolbar>
                    </Grid>
                  </div>
                  <hr />
                </Col>
                <Col lg={6}>
                  <div className="text-success fw-bold buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('mainMobile')}>
                    Update Main Banner Mobile <StarRateIcon />  {columnVisibility.mainMobile ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                  </div>
                  <div className="mt-2" style={{ display: columnVisibility.mainMobile ? 'block' : 'none' }}>
                    {photoFields?.map((item, index) => (
                      <div key={item.id} className="form-row ">
                        <div className="d-flex justify-content-around mb-2 mt-2">
                          <Button
                            variant="contained"
                            component="label"
                            {...register(`main_banner_mobile[${index}].file`)}
                            onClick={() => clearErrors(`main_banner_mobile[${index}].file`)} // Clear errors for URL when file input is clicked
                          >
                            Upload Banner
                            <input
                              type="file"
                              {...register(`main_banner_mobile[${index}].file`)}
                              hidden
                              onChange={(e) => handleImage(index, "main_banner_mobile", e)}
                              className={`file_button mb-1 ${errors.main_banner_mobile && errors?.main_banner_mobile?.file ? "error" : ""}`}
                            />
                          </Button>
                          {watch(`main_banner_mobile[${index}].image`) && (
                            <div className="image_div">
                              <img
                                src={watch(`main_banner_mobile[${index}].image`)}
                                alt=""
                                width={100}
                                height="auto"
                                className="rounded image"
                              />
                            </div>
                          )}
                        </div>
                        <div className="column">
                          <Controller
                            name={`main_banner_mobile[${index}].file`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Update Main Banner Mobile Image Url"
                                className={`form-control mb-2 mt-3 ${errors.main_banner_mobile &&
                                  errors?.main_banner_mobile[index]?.file
                                  ? "error"
                                  : ""
                                  }`}
                                value={field?.value || ""}
                                onChange={(e) => handleUrlChange(index, "main_banner_mobile", e)}
                              />
                            )}
                          />
                          <Controller
                            name={`main_banner_mobile[${index}].link`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Links"
                                className={`form-control mb-3 ${errors.main_banner_mobile &&
                                  errors?.main_banner_mobile[index]?.link
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                        </div>
                        <div className="d-flex gap-3">
                          <Controller
                            name={`main_banner_mobile[${index}].target`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Target"
                                select
                                className={`form-control mb-3 ${errors.main_banner_mobile &&
                                  errors?.main_banner_mobile[index]?.target
                                  ? "error"
                                  : ""
                                  }`}
                              >
                                <MenuItem value="_self">_self</MenuItem>
                                <MenuItem value="_blank">_blank</MenuItem>
                              </TextField>
                            )}
                          />
                          <Controller
                            name={`main_banner_mobile[${index}].order`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Order"
                                select
                                className={`form-control mb-3 ${errors.main_banner_mobile &&
                                  errors?.main_banner_mobile[index]?.order
                                  ? "error"
                                  : ""
                                  }`}
                              >
                                {[...Array(15).keys()].map((number) => (
                                  <MenuItem
                                    key={number + 1}
                                    value={(number + 1).toString()}
                                  >
                                    {number + 1}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          />
                        </div>

                        <div className="column">
                          <Controller
                            name={`main_banner_mobile[${index}].alt`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Alt"
                                className={`form-control ${errors.main_banner_mobile &&
                                  errors?.main_banner_mobile[index]?.alt
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                        </div>
                        <div className="column d-flex justify-content-end mt-2">
                          {photoFields.length > 0 &&
                            <Tooltip title="Delete" arrow>
                              <DeleteIcon onClick={() => removePhoto(index)} style={{ color: "red", cursor: "pointer" }} />
                            </Tooltip>
                          }
                        </div>
                      </div>
                    ))}
                    <div className="form-row">
                      <Grid className="d-flex justify-content-between">
                        <Tooltip title="Add" arrow>
                          <Button
                            className="button "
                            variant="outlined"
                            disableElevation
                            startIcon={<Add />}
                            onClick={() =>
                              appendPhoto({
                                file: null,
                                link: "",
                                target: "",
                                order: "",
                                alt: "",
                              })
                            }
                          >
                            Add
                          </Button>
                        </Tooltip>
                      </Grid>
                    </div>
                  </div>
                  <hr />
                </Col>
                <Col lg={6}>
                  <div className="d-flex justify-content-evenly">
                    <div className="text-success fw-bold buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('detailsMobile')}>
                      Update Detail Banner Mobile <StarRateIcon />  {columnVisibility.detailsMobile ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                    </div>
                    <Tooltip title="Copy Main Banner Mobile to Details Banner Mobile">
                      <div className="checkbox-container mt-2">
                        <input type="checkbox" checked={isChecked?.detail_banner_mobile} onChange={(e) => handleCheckboxChange(e, "detail_banner_mobile")} id="detailMobile" />
                        <label htmlFor="detailMobile" className="custom-checkbox-label">
                          <span className="slider"></span>
                        </label>
                      </div>
                    </Tooltip>
                  </div>
                  <div className="mt-2" style={{ display: columnVisibility.detailsMobile ? 'block' : 'none' }}>
                    {detailMobileFields?.map((item, index) => (
                      <div key={item.id} className="form-row ">
                        <div className="d-flex justify-content-around mb-2 mt-2">
                          <Button
                            variant="contained"
                            component="label"
                            {...register(`detail_banner_mobile[${index}].file`)}
                            onClick={() => clearErrors(`detail_banner_mobile[${index}].file`)} // Clear errors for URL when file input is clicked
                          >
                            Upload Banner
                            <input
                              type="file"
                              {...register(`detail_banner_mobile[${index}].file`)}
                              hidden
                              onChange={(e) => handleImage(index, "detail_banner_mobile", e)}
                              className={`file_button mb-1 ${errors.detail_banner_mobile && errors?.detail_banner_mobile?.file ? "error" : ""}`}
                            />
                          </Button>
                          {watch(`detail_banner_mobile[${index}].image`) && (
                            <div className="image_div">
                              <img
                                src={watch(`detail_banner_mobile[${index}].image`)}
                                alt=""
                                width={100}
                                height="auto"
                                className="rounded image"
                              />
                            </div>
                          )}
                        </div>
                        <div className="column">
                          <Controller
                            name={`detail_banner_mobile[${index}].file`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Update Main Banner Mobile Image Url"
                                className={`form-control mb-2 mt-3 ${errors.detail_banner_mobile &&
                                  errors?.detail_banner_mobile[index]?.file
                                  ? "error"
                                  : ""
                                  }`}
                                value={field?.value || ""}
                                onChange={(e) => handleUrlChange(index, "detail_banner_mobile", e)}
                              />
                            )}
                          />
                          <Controller
                            name={`detail_banner_mobile[${index}].link`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Links"
                                className={`form-control mb-3 ${errors.detail_banner_mobile &&
                                  errors?.detail_banner_mobile[index]?.link
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                        </div>
                        <div className="d-flex gap-3">
                          <Controller
                            name={`detail_banner_mobile[${index}].target`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Target"
                                select
                                className={`form-control mb-3 ${errors.detail_banner_mobile &&
                                  errors?.detail_banner_mobile[index]?.target
                                  ? "error"
                                  : ""
                                  }`}
                              >
                                <MenuItem value="_self">_self</MenuItem>
                                <MenuItem value="_blank">_blank</MenuItem>
                              </TextField>
                            )}
                          />
                          <Controller
                            name={`detail_banner_mobile[${index}].order`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Order"
                                select
                                className={`form-control mb-3 ${errors.detail_banner_mobile &&
                                  errors?.detail_banner_mobile[index]?.order
                                  ? "error"
                                  : ""
                                  }`}
                              >
                                {[...Array(15).keys()].map((number) => (
                                  <MenuItem
                                    key={number + 1}
                                    value={(number + 1).toString()}
                                  >
                                    {number + 1}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          />
                        </div>

                        <div className="column">
                          <Controller
                            name={`detail_banner_mobile[${index}].alt`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Alt"
                                className={`form-control ${errors.detail_banner_mobile &&
                                  errors?.detail_banner_mobile[index]?.alt
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                        </div>
                        <div className="column d-flex justify-content-end mt-2">
                          {detailMobileFields.length > 0 &&
                            <Tooltip title="Delete" arrow>
                              <DeleteIcon onClick={() => detailMobileRemove(index)} style={{ color: "red", cursor: "pointer" }} />
                            </Tooltip>
                          }
                        </div>
                      </div>
                    ))}
                    <div className="form-row">
                      <Grid className="d-flex justify-content-between">
                        <Tooltip title="Add" arrow>
                          <Button
                            className="button "
                            variant="outlined"
                            disableElevation
                            startIcon={<Add />}
                            onClick={() =>
                              detailMobileAppend({
                                file: null,
                                link: "",
                                target: "",
                                order: "",
                                alt: "",
                              })
                            }
                          >
                            Add
                          </Button>
                        </Tooltip>
                      </Grid>
                    </div>
                  </div>
                  <hr />
                </Col>
              </Row>
              {
                watch(`promotional_banner_desktop`) !== null ?
                  <Row >
                    <Col lg={6}>
                      <div className="text-success fw-bold text-center buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('promotional_banner_desktop')}>
                        Update Promotional Banner Desktop  {columnVisibility.promotional_banner_desktop ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                      </div>
                      <div style={{ display: columnVisibility.promotional_banner_desktop ? 'block' : 'none' }}>
                        {promotionFields.map((item, index) => (
                          <div key={item.id} className="form-row ">
                            <div className="d-flex justify-content-around mb-3 mt-2">
                              <Button
                                variant="contained"
                                component="label"
                                {...register(`promotional_banner_desktop[${index}].file`)}
                                onClick={() => clearErrors(`promotional_banner_desktop[${index}].file`)} // Clear errors for URL when file input is clicked
                              >
                                Upload File
                                <input
                                  type="file"
                                  {...register(`promotional_banner_desktop[${index}].file`)}
                                  hidden
                                  onChange={(e) => handleImage(index, "promotional_banner_desktop", e)}
                                  className={`file_button mb-1 ${errors.promotional_banner_desktop && errors?.promotional_banner_desktop?.file ? "error" : ""}`}
                                />
                              </Button>
                              {watch(`promotional_banner_desktop[${index}].image`) && (
                                <div className="image_div">
                                  <img
                                    src={watch(`promotional_banner_desktop[${index}].image`)}
                                    alt=""
                                    width={100}
                                    height="auto"
                                    className="rounded image"
                                  />
                                </div>
                              )}
                            </div>
                            <div className="column mb-2 mt-4">
                              <Controller
                                name={`promotional_banner_desktop[${index}].image`}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="Enter Main Banner Desktop Url"
                                    className={`form-control mb-2 ${errors.promotional_banner_desktop &&
                                      errors?.promotional_banner_desktop[index]?.image
                                      ? "error"
                                      : ""
                                      }`}
                                    value={field?.value || ""}
                                    onChange={(e) => handleUrlChange(index, "promotional_banner_desktop", e)}
                                  />
                                )}
                              />
                              <Controller
                                name={`promotional_banner_desktop[${index}].link`}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="Enter Link"
                                    className={`form-control mb-2 mt-2 ${errors.promotional_banner_desktop &&
                                      errors?.promotional_banner_desktop[index]?.link
                                      ? "error"
                                      : ""
                                      }`}
                                  />
                                )}
                              />
                            </div>
                            <div className="column mb-2 d-flex gap-3">
                              <Controller
                                name={`promotional_banner_desktop[${index}].target`}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="Enter Target"
                                    select
                                    className={`form-control mb-2  ${errors.promotional_banner_desktop &&
                                      errors?.promotional_banner_desktop[index]?.target
                                      ? "error"
                                      : ""
                                      }`}
                                  >
                                    <MenuItem value="_self">_self</MenuItem>
                                    <MenuItem value="_blank">_blank</MenuItem>
                                  </TextField>
                                )}
                              />
                              <Controller
                                name={`promotional_banner_desktop[${index}].order`}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="Enter Order"
                                    select
                                    className={`form-control mb-2 ${errors.promotional_banner_desktop &&
                                      errors?.promotional_banner_desktop[index]?.order
                                      ? "error"
                                      : ""
                                      }`}
                                  >
                                    {[...Array(15).keys()].map((number) => (
                                      <MenuItem
                                        key={number + 1}
                                        value={(number + 1).toString()}
                                      >
                                        {number + 1}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                )}
                              />
                            </div>
                            <div className="column">
                              <Controller
                                name={`promotional_banner_desktop[${index}].alt`}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="Enter Alt"
                                    className={`form-control ${errors.promotional_banner_desktop &&
                                      errors?.promotional_banner_desktop[index]?.alt
                                      ? "error"
                                      : ""
                                      }`}
                                  />
                                )}
                              />
                            </div>
                            <div className="column d-flex justify-content-end mt-2">
                              {promotionFields.length > 0 &&
                                <Tooltip title="Delete" arrow>
                                  <DeleteIcon onClick={() => promotionalRemove(index)} style={{ color: "red", cursor: "pointer" }} />
                                </Tooltip>
                              }
                            </div>
                          </div>
                        ))}
                        <Grid className="d-flex justify-content-between">
                          <Tooltip title="Add" arrow>
                            <Button
                              className="button "
                              variant="outlined"
                              disableElevation
                              startIcon={<Add />}
                              onClick={() =>
                                promotionalAppend({
                                  file: null,
                                  link: "",
                                  target: "",
                                  order: "",
                                  alt: "",
                                })
                              }
                            >
                              Add
                            </Button>
                          </Tooltip>
                        </Grid>
                      </div>
                      <hr className="mt-3" />
                    </Col>
                    <Col lg={6}>
                      <div className="text-success fw-bold text-center buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('promotional_banner_mobile')}>
                        Update  Promotional Banner Mobile  {columnVisibility.promotional_banner_mobile ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                      </div>
                      <div style={{ display: columnVisibility.promotional_banner_mobile ? 'block' : 'none' }}>
                        {promotionFieldsMobile.map((item, index) => (
                          <div key={item.id} className="form-row ">
                            <div className="d-flex justify-content-around mb-3 mt-2">
                              <Button
                                variant="contained"
                                component="label"
                                {...register(`promotional_banner_mobile[${index}].file`)}
                                onClick={() => clearErrors(`promotional_banner_mobile[${index}].file`)} // Clear errors for URL when file input is clicked
                              >
                                Upload File
                                <input
                                  type="file"
                                  {...register(`promotional_banner_mobile[${index}].file`)}
                                  hidden
                                  onChange={(e) => handleImage(index, "promotional_banner_mobile", e)}
                                  className={`file_button mb-1 ${errors.promotional_banner_mobile && errors?.promotional_banner_mobile?.file ? "error" : ""}`}
                                />
                              </Button>
                              {watch(`promotional_banner_mobile[${index}].image`) && (
                                <div className="image_div">
                                  <img
                                    src={watch(`promotional_banner_mobile[${index}].image`)}
                                    alt=""
                                    width={100}
                                    height="auto"
                                    className="rounded image"
                                  />
                                </div>
                              )}
                            </div>
                            <div className="column mb-2 mt-4">
                              <Controller
                                name={`promotional_banner_mobile[${index}].image`}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="Enter Main Banner Desktop Url"
                                    className={`form-control mb-2 ${errors.promotional_banner_mobile &&
                                      errors?.promotional_banner_mobile[index]?.image
                                      ? "error"
                                      : ""
                                      }`}
                                    value={field?.value || ""}
                                    onChange={(e) => handleUrlChange(index, "promotional_banner_mobile", e)}
                                  />
                                )}
                              />
                              <Controller
                                name={`promotional_banner_mobile[${index}].link`}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="Enter Link"
                                    className={`form-control mb-2 mt-2 ${errors.promotional_banner_mobile &&
                                      errors?.promotional_banner_mobile[index]?.link
                                      ? "error"
                                      : ""
                                      }`}
                                  />
                                )}
                              />
                            </div>
                            <div className="column mb-2 d-flex gap-3">
                              <Controller
                                name={`promotional_banner_mobile[${index}].target`}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="Enter Target"
                                    select
                                    className={`form-control mb-2  ${errors.promotional_banner_mobile &&
                                      errors?.promotional_banner_mobile[index]?.target
                                      ? "error"
                                      : ""
                                      }`}
                                  >
                                    <MenuItem value="_self">_self</MenuItem>
                                    <MenuItem value="_blank">_blank</MenuItem>
                                  </TextField>
                                )}
                              />
                              <Controller
                                name={`promotional_banner_mobile[${index}].order`}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="Enter Order"
                                    select
                                    className={`form-control mb-2 ${errors.promotional_banner_mobile &&
                                      errors?.promotional_banner_mobile[index]?.order
                                      ? "error"
                                      : ""
                                      }`}
                                  >
                                    {[...Array(15).keys()].map((number) => (
                                      <MenuItem
                                        key={number + 1}
                                        value={(number + 1).toString()}
                                      >
                                        {number + 1}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                )}
                              />
                            </div>
                            <div className="column">
                              <Controller
                                name={`promotional_banner_mobile[${index}].alt`}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="Enter Alt"
                                    className={`form-control ${errors.promotional_banner_mobile &&
                                      errors?.promotional_banner_mobile[index]?.alt
                                      ? "error"
                                      : ""
                                      }`}
                                  />
                                )}
                              />
                            </div>
                            <div className="column d-flex justify-content-end mt-2">
                              {promotionFieldsMobile.length > 0 &&
                                <Tooltip title="Delete" arrow>
                                  <DeleteIcon onClick={() => promotionalRemoveMobile(index)} style={{ color: "red", cursor: "pointer" }} />
                                </Tooltip>
                              }
                            </div>
                          </div>
                        ))}
                        <Grid className="d-flex justify-content-between">
                          <Tooltip title="Add" arrow>
                            <Button
                              className="button "
                              variant="outlined"
                              disableElevation
                              startIcon={<Add />}
                              onClick={() =>
                                promotionalAppendMobile({
                                  file: null,
                                  link: "",
                                  target: "",
                                  order: "",
                                  alt: "",
                                })
                              }
                            >
                              Add
                            </Button>
                          </Tooltip>
                        </Grid>
                      </div>
                      <hr className="mt-3" />
                    </Col>
                  </Row>
                  : ""
              }

              <Row className="mt-3">
                <Col lg={6}>
                  {" "}
                  <div className="column">
                    <TextField
                      type="text"
                      {...register(`main_heading`)}
                      className={`form-control mb-2 ${errors.main_heading ? "error" : ""
                        }`}
                      label="Enter heading"
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="column">
                    <TextField
                      type="text"
                      {...register(`main_subHeading`)}
                      className={`form-control mb-2 ${errors.main_subHeading ? "error" : ""
                        }`}
                      label="Enter sub heading "
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <div className="column">
                      <label
                      className="fw-semibold mb-1 text-secondary"
                      style={{ fontSize: '0.85rem', letterSpacing: '0.5px' }}
                    >
                      Enter Disclaimer Content
                    </label>
                    <JoditEditor
                      ref={register(`disclaimer`)}
                      onChange={handleEditor}
                      value={disclaimerData}
                    />
                  </div>
                </Col>
                <hr className="mt-3" />
              </Row>
               <Row>
                <Col lg={12}>
                  <div className="column">
                    <label
                      className="fw-semibold mb-1 text-secondary"
                      style={{ fontSize: '0.85rem', letterSpacing: '0.5px' }}
                    >
                      Enter Footer Content
                    </label>
                    <JoditEditor
                      ref={register(`footer_content`)}
                      onChange={handleFooterContentEditor}
                      value={footerContentData}
                    />
                  </div>
                </Col>
                <hr className="mt-3" />
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="text-success buttons rounded-2 fw-bolder mb-3  " style={{ cursor: "pointer" }} onClick={() => toggleColumn('partners')}>
                    Update Partners  <StarRateIcon />  {columnVisibility.partners ? <span><ExpandMoreIcon /></span> : <span><ExpandLessIcon /></span>}
                  </div>
                  <div style={{ display: columnVisibility?.partners ? 'block' : 'none' }}>
                    {partnersFields?.map((item, index) => (
                      <div key={item.id} className="form-row ">
                        <div className="d-flex justify-content-around mb-3 mt-2">
                          <Button
                            variant="contained"
                            component="label"
                            {...register(`partners.file`)}
                            onClick={() => clearErrors(`partners.file`)} // Clear errors for URL when file input is clicked
                          >
                            Upload File
                            <input
                              type="file"
                              {...register(`partners.file`)}
                              hidden
                              onChange={(e) => handleImage(index, "partners", e)}
                              className={`file_button mb-1 ${errors.partners && errors?.partners?.file ? "error" : ""}`}
                            />
                          </Button>
                          {watch(`partners[${index}].logo`) && (
                            <div className="image_div">
                              <img
                                src={watch(`partners[${index}].logo`)}
                                alt=""
                                width={100}
                                height="auto"
                                className="rounded image"
                              />
                            </div>
                          )}
                        </div>
                        <div className="column">
                          <Controller
                            name={`partners[${index}].file`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Banner Url"
                                className={`form-control mb-3 ${errors.partners &&
                                  errors?.partners[index]?.file
                                  ? "error"
                                  : ""
                                  }`}
                                value={field?.value || ""}
                                onChange={(e) => handleUrlChange(index, "partners", e)}
                              />
                            )}
                          />
                          <Controller
                            name={`partners[${index}].order`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Order"
                                select
                                className={`form-control mb-2 ${errors.partners &&
                                  errors?.partners[index]?.order
                                  ? "error"
                                  : ""
                                  }`}
                              >
                                {[...Array(15).keys()].map((number) => (
                                  <MenuItem
                                    key={number + 1}
                                    value={(number + 1).toString()}
                                  >
                                    {number + 1}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          />
                        </div>
                        <div className="d-flex justify-content-end">
                          {partnersFields.length > 0 &&
                            <DeleteIcon onClick={() => partnersRemove(index)} style={{ color: "red", cursor: "pointer" }} />
                          }
                        </div>
                      </div>
                    ))}
                    <div className="form-row">
                      <Grid className="d-flex justify-content-between">
                        <Toolbar className="p-0">
                          <Button
                            className="button "
                            variant="outlined"
                            disableElevation
                            startIcon={<Add />}
                            onClick={() =>
                              partnersAppend({
                                file: null,
                                link: "",
                                target: "",
                                order: "",
                                alt: "",
                              })
                            }
                          >
                            Add
                          </Button>
                        </Toolbar>
                      </Grid>
                    </div>
                  </div>
                  <hr />
                </Col>
                <Col lg={6}>
                  <div className="column">
                    <TextField
                      type="text"
                      {...register(`partners_heading`)}
                      className={`form-control mb-2 ${errors.partners_heading ? "error" : ""
                        }`}
                      label="Enter Partners Heading *"
                    />
                  </div>
                  <div className="column">
                    <TextField
                      type="text"
                      {...register(`partners_subHeading`)}
                      className={`form-control mb-2 ${errors.partners_subHeading ? "error" : ""
                        }`}
                      label="Enter Partners Sub-Heading *"
                    />
                  </div>
                  <hr />
                </Col>
              </Row>

              <Grid className="d-flex justify-content-between">
                <Toolbar className="p-0">
                  <Button
                    className="button"
                    variant="contained"
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Back
                  </Button>
                </Toolbar>
                {isLoading ? (
                  <Toolbar className="p-0">
                    <Button
                      className="button "
                      variant="contained"
                      disableElevation
                    >
                      Loading...
                      <CircularProgress color="success" size="1.7rem" />
                    </Button>
                  </Toolbar>
                ) : (
                  <Toolbar className="p-0">
                    <Button
                      className="button "
                      variant="contained"
                      disableElevation
                      type="submit"
                    >
                      Update
                    </Button>
                  </Toolbar>
                )}
              </Grid>
            </div>
          </form>
        </div>
      </Paper>
    </Box>
  );
};

export default UpdateBody;
